const variantDescription = (variant, delimeter = ' / ') => {
  if (variant?.option_values && variant?.option_values?.length > 0) {
    return variant.option_values.map(ov => ov.name).join(delimeter)
  } else if (variant?.name) {
    return variant?.name
  } else if (variant?.sku) {
    return variant?.sku
  }

  return ''
}

const transformProductsToVariants = products => {
  const variants = []

  products.forEach(p => {
    if (!p.categories.length || !p.variants.length) {
      return
    }

    const category = p.categories[0]

    if (!category || !category.id) {
      return
    }

    p.variants.forEach(variant => {
      variants.push({
        product: {
          id: p.id,
          short_id: p.short_id,
          slug: p.slug,
          name: p.name,
        },
        variant,
        category,
      })
    })
  })

  return variants
}

export {
  variantDescription,
  transformProductsToVariants,
}
